import Cover1 from 'assets/teamCover/1.jpg'
import Cover10 from 'assets/teamCover/10.jpg'
import Cover11 from 'assets/teamCover/11.jpg'
import Cover12 from 'assets/teamCover/12.jpg'
import Cover13 from 'assets/teamCover/13.jpg'
import Cover14 from 'assets/teamCover/14.jpg'
import Cover15 from 'assets/teamCover/15.jpg'
import Cover16 from 'assets/teamCover/16.jpg'
import Cover17 from 'assets/teamCover/17.jpg'
import Cover18 from 'assets/teamCover/18.jpg'
import Cover19 from 'assets/teamCover/19.jpg'
import Cover2 from 'assets/teamCover/2.jpg'
import Cover20 from 'assets/teamCover/20.jpg'
import Cover3 from 'assets/teamCover/3.jpg'
import Cover4 from 'assets/teamCover/4.jpg'
import Cover5 from 'assets/teamCover/5.jpg'
import Cover6 from 'assets/teamCover/6.jpg'
import Cover7 from 'assets/teamCover/7.jpg'
import Cover8 from 'assets/teamCover/8.webp'
import Cover9 from 'assets/teamCover/9.jpg'
import { TeamData } from '../components/Modals/TeamCaptainPanel/types'; // Adjust path as needed

const imgTeamCover = [
  Cover1,
  Cover2,
  Cover3,
  Cover4,
  Cover5,
  Cover6,
  Cover7,
  Cover8,
  Cover9,
  Cover10,
  Cover11,
  Cover12,
  Cover13,
  Cover14,
  Cover15,
  Cover16,
  Cover17,
  Cover18,
  Cover19,
  Cover20,
]

export const getCoverPhoto = (input: string | TeamData | any): string => {
  // If no input, return default cover
  if (!input) {
    return imgTeamCover[0];
  }

  // If input is an object with cover_photo.url, use the uploaded cover photo
  if (input && typeof input === 'object' && input.cover_photo?.url) {
    return input.cover_photo.url;
  }

  // Extract the team name based on input type for fallback
  let teamName: string;

  if (typeof input === 'string') {
    // If input is a string, use it directly
    teamName = input;
  } else if (input && typeof input === 'object') {
    // If input is an object, check for team_name property
    teamName = input.team_name || 'DefaultTeam';
  } else {
    // Fallback
    teamName = 'DefaultTeam';
  }

  // Calculate index based on team name for generated fallback cover
  let index = 0;
  for (let i = 0; i < teamName.length; i++) {
    index += teamName.charCodeAt(i);
  }

  return imgTeamCover[index % 20];
}